// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3052":"7c56d87a","3600":"2bfd6c85"}[chunkId] + ".chunk.css";
};